import {User, UserManager} from "oidc-client";

// Memorizes the last sign in promise to avoid having simultaneous sign ins
let currentSignInPromise: Promise<User> | null = null;

export async function signInUser(userManager: UserManager): Promise<User> {
  if (currentSignInPromise) {
    console.log("signInUser: already signin running => skip")
    return currentSignInPromise;
  } else {
    currentSignInPromise = startSignInUser(userManager).finally(() => {
      currentSignInPromise = null;
    });
    return currentSignInPromise;
  }
}

async function startSignInUser(userManager: UserManager): Promise<User> {
  const user = await userManager.getUser();
  // Minimum number of seconds the access token needs to have before we refresh it
  const minExpirationTime = userManager.settings.accessTokenExpiringNotificationTime || 60;
  const userOk = user && user.expires_in && (user.expires_in > minExpirationTime);
  if (userOk) return user!!;
  console.log(`#startSignInUser, current user (user: ${user} expiresIn: ${user?.expires_in}) not loaded or expired, removing old tokens, triggering signinSilent`);
  if(user) {
    await userManager.removeUser();
  }
  await userManager.clearStaleState();
  return userManager.signinSilent()
    .catch((e) => {
      console.log(`#startSignInUser, signinSilent failed: ${e} => redirect to login page`);
      userManager.signinRedirect({
        state: {
          originHref: window.location.href,
        }
      });
      // Return promise that never resolves, because a redirect will come
      return new Promise(_ => {
      });
    });
}
